import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-eb11a36a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "first-class"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  class: "nav"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "time"
};
const _hoisted_6 = {
  class: "botPart"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "amount"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["title"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "｜", -1));

const _hoisted_13 = ["title"];
import { ref, reactive, defineComponent, onUpdated, onMounted } from 'vue';
import VideoDialog from '@/pages/components/FilePreview/VideoDialog.vue';
export default {
  props: ['userInfo', 'courseData', 'authType', 'showResultTag', 'resultMap'],

  setup(__props) {
    const props = __props;
    const feature = ref();
    const videoInfo = reactive({
      url: props.courseData.fileUrl,
      title: props.courseData.videoName
    });

    function convertSecondsToMMSS(seconds) {
      if (seconds < 0) {
        throw new Error('Seconds must be a positive number.');
      }

      const minutes = Math.floor(seconds / 60); // 取整

      const remainingSeconds = seconds % 60; // 余数

      return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`; // 格式化秒数，不足两位前面补0
    }

    const headerNumIndex = ref(0);
    const showVideoDialog = ref(false);
    const searchInfo = ref('综合排序');

    const handleHeaderTab = index => {
      headerNumIndex.value = index;
    };

    const handleClose = () => {
      showVideoDialog.value = false;
    }; //切换排序


    function handleSort(item, index) {
      searchInfo.value = item.name;
    }

    console.log(props.course, 'course'); //打开视频弹窗

    const handleVideo = () => {
      showVideoDialog.value = true;
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "content",
        onClick: handleVideo
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: __props.courseData.videoCover,
        alt: "",
        width: "266",
        height: "155"
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(convertSecondsToMMSS(__props.courseData.videoDuration)), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
        title: __props.courseData.videoName
      }, _toDisplayString(__props.courseData.videoName), 9, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
        width: "16",
        height: "16",
        src: __props.courseData.avatar || require('@/assets/images/common/teacher_icon.png'),
        alt: ""
      }, null, 8, _hoisted_10), _createElementVNode("span", {
        title: __props.courseData.lecturer,
        class: "span_1"
      }, _toDisplayString(__props.courseData.lecturer), 9, _hoisted_11), _hoisted_12, _createElementVNode("span", {
        title: __props.courseData.organName,
        class: "span_2"
      }, _toDisplayString(__props.courseData.organName), 9, _hoisted_13)])])])]), _createVNode(VideoDialog, {
        show: showVideoDialog.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showVideoDialog.value = $event),
        videoInfo: _unref(videoInfo)
      }, null, 8, ["show", "videoInfo"])]);
    };
  }

};